import EzModalController from 'layouts/modal/modal-controller';
import shave from 'shave';

export default class CollectionsAlertController extends EzModalController {
  static targets = ['collectionName']

  fadeDuration = 500;

  displayDuration = 4000;

  connect() {
    const numLines = 1;
    const titleLineHeight = parseInt(getComputedStyle(this.collectionNameTarget).lineHeight, 10);
    const targetTitleHeight = titleLineHeight * numLines;

    this.element.addEventListener('mouseenter', this.clearTimer);

    shave('.collections-alert__link a', targetTitleHeight, { spaces: false });
    this.slideIn();

    window.addEventListener('hideCollectionAlert', this.hide);
  }

  disconnect() {
    window.removeEventListener('hideCollectionAlert', this.hide);
  }

  clearTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.element.classList.remove('is-slid-out');
      this.element.addEventListener('mouseleave', this.slideIn);
    }
  }

  slideIn = () => {
    this.element.classList.remove('is-slid-out');

    this.timer = setTimeout(() => {
      this.slideOut();
    }, this.fadeDuration + this.displayDuration);
  }

  slideOut = () => {
    this.element.classList.add('is-slid-out');

    this.timer = setTimeout(() => {
      this.remove();
    }, this.fadeDuration);
  }

  hide = () => {
    this.element.classList.add('is-hidden');

    setTimeout(() => {
      this.remove();
    }, this.fadeDuration);
  }

  remove = () => {
    this.element.removeEventListener('mouseleave', this.slideIn);
    this.element.removeEventListener('mouseenter', this.clearTimer);
    this.element.remove();
  }
}
